// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container[data-v-f3d2f1e8]{margin-top:15px}.container img[data-v-f3d2f1e8]{width:100%}", "",{"version":3,"sources":["webpack://./js.autoload/vueComponents/top_banner.vue"],"names":[],"mappings":"AAAA,4BAAW,eAEX,CAF2B,gCAAe,UAM1C","sourcesContent":[".container{margin-top:15px}.container img{width:100%}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
